import PropTypes from 'prop-types';

import { Paragraph } from '@cof/plastic-components';
import { css, styled } from 'styled-components';

import Label from '../Label';
import LinkButton from '../LinkButton';

const AddressLine = styled.span`
    display: block;
    ${({ theme }: any) => css`
        font-weight: ${theme.fontWeights.medium};
    `}
`;
const Wrapper = styled.div`
    ${({ theme }: any) => css`
        border: 0.3rem solid ${theme.colors.global.grey50};
        padding: ${theme.space.sm} ${theme.space.sm} ${theme.space.md};
        margin-bottom: ${theme.space.sm};
    `}
`;

const SelectedAddressDetails = ({ address = null, selectDifferentAddress, addressType }: any) =>
    address ? (
        <>
            <Label data-qm-allow>{addressType === 'current-address' ? 'Your address' : 'Your previous address'}</Label>
            <Wrapper>
                <Paragraph data-qa-id={`${addressType}-selected-address`} aria-live="polite" role="alert">
                    {address
                        .replace(/,\s/g, ', .')
                        .split(' .')
                        .map((addressLine: any, index: any) => (
                            <AddressLine key={index}>{addressLine}</AddressLine>
                        ))}
                </Paragraph>
                <LinkButton
                    data-qa-id={`${addressType}-edit-link`}
                    mt="sm"
                    onClick={() => selectDifferentAddress(true)}
                    data-qm-allow
                >
                    Select different address
                </LinkButton>
            </Wrapper>
        </>
    ) : null;

SelectedAddressDetails.displayName = 'SelectedAddressDetails';

SelectedAddressDetails.propTypes = {
    address: PropTypes.string,
    selectDifferentAddress: PropTypes.func.isRequired,
    addressType: PropTypes.string.isRequired
};

export default SelectedAddressDetails;
